export default __webpack_public_path__ + "static/media/user-banner.b5eb61aa.png";